<template lang="pug">
  .view-tags.content
    form-modal(form="tag-form" :title="modalTitle" v-model="modalValue" @save="storeTag()" @close="closeModal()" :active.sync="isModalActive")

    ui-navbar-panel(title="Метки тикетов")
      b-button(type="is-primary", icon-left="plus-circle" @click="newTag()") Новая метка

    .column.is-7-desktop
      b-table(
        :data="tags.items",
        :loading="tags.$state.loading",
        detail-key="id",
        default-sort="name",
        striped
      )
        //- Row
        b-table-column(field="id", label="ID", width="1", nowrap, sortable, numeric, v-slot="{row}")
          | {{ row.id }}

        b-table-column(field="status", label="Статус", width="1", nowrap, sortable, v-slot="{row}")
          b-tooltip(:label="row.status_label")
            b-icon(v-if="row.is_active", icon="check-circle", type="is-success")
            b-icon(v-else, icon="minus-circle", type="is-dark")

        b-table-column(field="name", label="Название", sortable v-slot="{row}")
          span(:class="'tag ' + row.color")
            | {{ row.name }}

        b-table-column(field="tasks_count", label="Кол-во задач", nowrap, sortable, numeric, v-slot="{row}")
          | {{ +row.tasks_count }}

        b-table-column(field="created_at", label="Добавлена", sortable v-slot="{row}")
          | {{ row.created_at | dateFormat }}

        b-table-column(field="edit", label="", v-slot="{row}")
          b-tooltip(:label="'Редактировать ' + row.name")
            b-icon(icon="pencil-outline", style="cursor: pointer;" size="is-small" @click.native="editTag(row.id)")

        b-table-column(field="delete", label="", v-slot="{row}")
          b-tooltip(:label="'Удалить ' + row.name")
            b-icon(icon="close", style="cursor: pointer;" size="is-small" @click.native="deleteTag(row.id)")
</template>

<script>
import Tag from '@/models/Tag';

export default {
  name: 'view-tags',

  data: () => ({
    tags: Tag.collection(),
    modalTitle: null,
    modalValue: null,
    isModalActive: false,
  }),

  watch: {
    $route() {
      this.loadTags();
    },
  },

  methods: {
    loadTags() {
      this.tags.$fetch({ scope: 'tasksCount' });
    },

    closeModal() {
      this.isModalActive = false;
      this.modalValue.$reset();
    },

    newTag() {
      this.modalTitle = 'Новая метка';
      this.modalValue = new Tag({is_active: true});
      this.isModalActive = true;
    },

    storeTag() {
      this.modalValue.$save().then(() => {
        this.isModalActive = false;
        this.loadTags();
      });
    },

    editTag(id) {
      this.modalTitle = 'Редактирование метки';
      this.modalValue = this.tags.find(id);
      this.isModalActive = true;
    },

    deleteTag(id) {
      this.tags.$delete(id);
    },
  },

  created() {
    this.loadTags();
  },
}
;
</script>
